import * as React from 'react';
import useAuth from '@sdk/authentication/useAuth';

import type { OpenPremiumGuardModal } from './PremiumGuard';
import usePremiumGuardBuilder, { PremiumGuardType } from './usePremiumGuardBuilder';

const PremiumGuardContext = React.createContext<PremiumGuardType>(null);

type Props = {
  children: React.ReactNode;
  openPremiumGuardModal: OpenPremiumGuardModal;
  openPricingModal: () => void;
  openLaborCostVideoModal: () => void;
};

const PremiumGuardProvider = ({
  children,
  openPremiumGuardModal,
  openPricingModal,
  openLaborCostVideoModal,
}: Props) => {
  const auth = useAuth();

  const premiumGuard = usePremiumGuardBuilder(
    auth,
    openPremiumGuardModal,
    openPricingModal,
    openLaborCostVideoModal
  );

  return (
    <PremiumGuardContext.Provider value={premiumGuard}>{children}</PremiumGuardContext.Provider>
  );
};

export { PremiumGuardContext, PremiumGuardProvider };
